import type { LanguageCode } from "config/languages";
import { getParentLanguage } from "utils/localeUtils";
import { languagesWithoutMagnitudePages, regularPages } from "./config";
import type { PageName } from "./types";

const buildRegularPageUrl = (language: LanguageCode, url: string, isExternal?: boolean): string => {
  const fullSlug = url ? `${url}/` : "";
  return isExternal ? url : `/${language}/${fullSlug}`;
};

const getRegularPageUrl = (language: LanguageCode, pageName: PageName): string => {
  const page = regularPages[pageName];
  const parentLanguage = getParentLanguage(language);

  const {
    [language]: languageUrl,
    [parentLanguage]: parentLanguageUrl,
    fallback: fallbackUrl,
    en: englishUrl,
    isExternal,
    parentLanguageOnly,
  } = page;

  if (languageUrl) return buildRegularPageUrl(language, languageUrl, isExternal);
  if (!languageUrl && languagesWithoutMagnitudePages.includes(language))
    return buildRegularPageUrl(parentLanguage, parentLanguageUrl, isExternal);

  if (parentLanguageUrl)
    return parentLanguageOnly
      ? buildRegularPageUrl(parentLanguage, parentLanguageUrl, isExternal)
      : buildRegularPageUrl(language, parentLanguageUrl, isExternal);
  if (fallbackUrl) return buildRegularPageUrl(language, fallbackUrl, isExternal);

  return buildRegularPageUrl("en", englishUrl);
};

export default getRegularPageUrl;
